namespace Gordic.Vyp.Lists {
    @Decorators.gcontent
    export class VypraveniZasilekListPage extends GContentBase<VypListBasePage>
    {
        IfPredplnení: boolean;
        IxsDpo: string;
        VypraveniDto: Wfl.Interface.GVypraveniZasilekDto
        MoznoVypravit: boolean;
        paramInfoOStavechHK: number;
        PovoleneKuryry: Wfl.Interface.GWflczpdDto[];

        onContentReady() {
            const that = this;
            this.IfPredplnení = this.IfMoznoPredplneni();
            this.model.ZpusobDor = this.ZpusobDorProp;
            Wfl.ListAC.WflZasilkyListBaseAC.InitList(this);
            this.specialActions.push(this.CreateActionVypravit());
            if (this.ZpusobDorProp == Wfl.Interface.WflczpdEnum.DatovaSchranka)
            {
                this.specialActions.push(this.CreateActionOveritAdresaty());
                if (this.PovolenoHKP) this.specialActions.push(Wfl.ListAC.WflZasilkyListBaseAC.CreateActionDetailEsuNad(this, false));
            }

            if (this.ZpusobDorProp == Wfl.Interface.WflczpdEnum.HybridniPosta && this.paramInfoOStavechHK == 2) this.specialActions.push(this.CreateActionInfoOZasilkachHP());

            if (this.IfPredplnení) {
                VypListBasePage.CreateActionsPredplneni(this);
                this.specialActions.push(VypListBasePage.CreateActionZmenaHodnot(this, true));
            }

            if (this.ZpusobDorProp == Wfl.Interface.WflczpdEnum.Posta)
            {
                VypListBasePage.CreateFrankovaniActions(this);
                if (this.VypraveniSettings.prevzetiDataMatrixEnabled) this.specialActions.push(VypListBasePage.CreateActionPrevzitSFrankovanim(this));
            }

            VypListBasePage.CreateActionsTisk(this);
            this.printActionsSubmenu.push(VypListBasePage.CreateActionTiskVypravenychDokSpis(this))
            Gordic.Wfl.ListAC.WflListBaseAC.CompleteMenu(this);
            // samotná definice gfilterpanelu
            this.filterForm = $("<div>")
                .appendTo(this.element)
                .on("gfilterpanelapply", function (event, obj) {
                    that.LoadData(obj.filter, true);
                }).gfilterpanel({
                    forms: that.CreateFilterForm(), // poleFormu ktere budou pouzity pro podminky
                    filterViewMode: FilterViewMode.Simple,
                    //simpleMode: true,
                    favorites: "all",                           // defaultní oblíbené
                    filterStorageService: new Gordic.Gin.FilterStorageService.Store({ tema: "vyp_ptm_vypzas" }),
                    poVyhledaniZobrazit: "OblibenePodminky",
                    favoriteLayoutDescriptor: Gordic.Gin.Globals.Enums.LayoutDescriptorType.list,
                })

            this.filterForm.gfilterpanel("applyFilter", $.extend(this.model), !this.NacistSeznamPriOtevreni)

            //form    
            this.defaultForm = $("<div>").appendTo(this.element).gform("createFrom", this.CreateDefaultForm());
            this.findForms("FormVyp").findFields().gfield("model", "apply", this.model).gfield("model", "validators", this.model);
            this.findForms("FormVyp").findFields().gfield("model", "apply", this.VypraveniDto).gfield("model", "validators", this.VypraveniDto);
            this.findForms("FormVyp").findFields().gfield("model", "apply", this.Predplneni).gfield("model", "validators", this.Predplneni);
            Lists.VypListBasePage.CreateGridZasilekVyp(this);
            Wfl.AC.WflBaseAC.ResolveInfo(this);
        }

        CreateFilterForm() {
            var filterForm = new Gordic.Forms.Form({ name: "FormDocsList", tabLabel: "jres:23900172", layoutDescriptor: "L2M2S1, L-3-8-1;, M-1;2-1;-1;, S-1;2-1;-1;, breaks-700-1;000" }) //RC 23900172 : Kompletní filtr
            filterForm.addRow().addField("gcheck", "", { name: "Vlastni", model: "model.Vlastni=value", label: "jres:23900011", initialValue: this.model.Vlastni  }); //RC 23900011 : Vlastní
            return [filterForm];
        }

        CreateDefaultForm() {
            // form
            const form = new Gordic.Forms.Form({ name: "FormVyp", layoutDescriptor: "L1;M1;S1;" });
            form.addSection();
            if (this.ZpusobDorProp == Wfl.Interface.WflczpdEnum.Posta) {
                form.addRow("jres:23900021" + ", " + "jres:23900022")
                    .addField("gselectbox", "w-4", Gordic.Prefabs.Select.ginspsc(), { name: "psc", model: "model.psc=value.psc; model.stat=value.stat" }) //RC 23900021; : PSČ
                    .addField("gselectbox", "w-8", Gordic.Prefabs.Select.gincsta(), { name: "stat", model: "model.stat=value.stat" }) //RC 23900022 : Stát
            }
            if (this.ZpusobDorProp == Wfl.Interface.WflczpdEnum.DorucovaciSluzba)
            {
                form.addRow("jres:23900023").addField("gselectbox", Gordic.Prefabs.Select.wflsdos(), { name: "dor_sluzba", model: "model.dor_sluzba=value.dor_sluzba" } ) //RC 23900023 : Doručovací služba
            }

            if (this.ZpusobDorProp == Wfl.Interface.WflczpdEnum.Kuryr && this.PovoleneKuryry.length > 1)
            {
                form.addRow("jres:23900198").addField("gselectbox", Gordic.Prefabs.Select.wflczpd(), { name: "zpusob_dor", model: "model.ZpusobDor=value.zpusob_dor", data: new Gordic.Data.View(this.PovoleneKuryry, { key: "zpusob_dor" }) }) //RC 23900198 : Typ kurýra
            }

            switch (this.ZpusobDorProp) {
                case Wfl.Interface.WflczpdEnum.DatovaSchranka:
                case Wfl.Interface.WflczpdEnum.GEX:
                case Wfl.Interface.WflczpdEnum.HybridniPosta:
                    form.addRow().addField("gcheck", "", { name: "VratitNevypravene", model: "model.VratitNevypravene=value", label: "jres:23900064" }); //RC 23900064 : Automaticky vrátit nevypravené zásilky odesílateli
                    break;
            }
            if (this.IfPredplnení) form.addPrefab(VypPrefabs.SekcePredplneniZasilek());
            return form;
        }

        IfMoznoPredplneni(): boolean {
            var l_ret = false;
            switch (this.ZpusobDorProp) {
                case Wfl.Interface.WflczpdEnum.Posta:
                case Wfl.Interface.WflczpdEnum.DorucovaciSluzba:
                case Wfl.Interface.WflczpdEnum.Kuryr:
                    l_ret = true;
                    break;
            }
            return l_ret;
        }

        LoadData(filtr?: Wfl.Interface.GSeznamZasilekFilterDto, plnitTempTabulku?: Boolean) {
            const that = this;
            Gin.Globals.ShowWaitLoadData(this);

            that.findForms("FormVyp").findFields().gfield("model", "collect", that.model);
            this.model = $.extend({}, this.model, filtr);

            this.call<Gordic.Wfl.Interface.GSeznamZasilekDto[]>("LoadDataThis", { model: this.model, plnitTempTabulku: plnitTempTabulku })
                .done(function (data)
                {
                    if (plnitTempTabulku) Gordic.Wfl.ListAC.WflListBaseAC.ClearResultInfo(that);
                    else {
                        if (that.resultInfo && that.resultInfo.length > 0) {
                            Gordic.Wfl.ListAC.WflListBaseAC.ApplyResultInfo(that, data as Wfl.Interface.GResultWorkListDto[])
                        }
                    }
                    Gordic.Wfl.ListAC.WflListBaseAC.ResolveResultData(that, data, true, Gin.Interface.TypVysledkuOperace.Provedeno);
                    if (!plnitTempTabulku || !Gordic.Vyp.AppSettings.GetVypraveniSettings(that).zasilky_k_vypraveni_neoznacovat)
                    {
                        Gordic.Wfl.ListAC.WflListBaseAC.OznacRadkyDlePriznaku(that);
                    }
                })
                .always(function () { Gordic.Wfl.ListAC.WflListBaseAC.AfterLoadData(that); });
        }

        ReloadData()
        {
            this.LoadData(this.model, true);
        }

        RefreshData() {
            this.LoadData(this.model, false);
        }

        CreateActionVypravit(): GAction {
            const that = this;
            var action = new GAction({
                name: Gordic.Vyp.Globals.Enums.ActionsName.Vypravit,
                icon: Gordic.Gin.Icons.ActionEnum.vypravit,
                caption: "jres:23900012", //RC 2390001;2 : Vypravit
                tooltip: "jres:23900012",
                groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite,
                enabled: that.MoznoVypravit,
                run: function (ev, ctx) {
                    that.findForms("FormVyp").findFields().gfield("model", "collect", that.VypraveniDto);

                    that.VypraveniDto.UkoncitDnesniVypraveni = true;
                    var l_asSelected = that.GetSelectedZasilkyVypraveniListDto();
                    if (l_asSelected.length > 0) {
                        that.TypProvedeneAkce = Wfl.Interface.TypAkce.vypraveni;
                        that.resultInfo = [];
                        switch (that.ZpusobDorProp) {
                            case Wfl.Interface.WflczpdEnum.Posta:
                                if (!that.VypraveniDto.psc) {
                                    that.dialogs.warning("jres:23900025"); //RC 23900025 : Není vyplněna pošta pro vypravení zásilek.
                                    return;
                                }
                                if (!that.VypraveniDto.stat) {
                                    that.dialogs.warning("jres:23900053"); //RC 23900053 : Není vyplněn stát
                                    return;
                                }
                                break;
                            case Wfl.Interface.WflczpdEnum.DorucovaciSluzba:
                                if (!that.VypraveniDto.dor_sluzba) {
                                    that.dialogs.warning("jres:23900024"); //RC 23900024 : Není vyplněna doručovací služba pro vypravení zásilek.
                                    return;
                                }
                                break;
                        }

                        if (Gordic.Vyp.AppSettings.GetVypraveniSettings(that).dotaz_pri_vypraveni)
                        {
                            that.dialogs.confirm("jres:23900014", "jres:23900013").on("close", function (ev, retVal)//RC 23900013 : Opravdu chcete vybrané zásilky vypravit?
                            {
                                if (retVal && retVal === "yes") that.Vypravit(l_asSelected);
                            });
                        } else that.Vypravit(l_asSelected)
                    }
                    else Wfl.ListAC.WflListBaseAC.ShowInfoNeniVybranZadnyRadek(that);
                }
            });
            return action;
        }

        Vypravit(_asSelected: Wfl.Interface.GZasilkyVypraveniWorkListDto[] )
        {
            const that = this;
            var l_asSelected = Wfl.ListAC.WflZasilkyListBaseAC.GetSelectedGZasilkaEditListDto(this);
            if (l_asSelected.length > 0)
            {
                if (this.NeulozenaData === true) {
                    this.call<Gin.Interface.GResultInfo[]>("UlozitZmenyZasilek", { Selected: l_asSelected })
                        .done(function (r) {
                            that.VypravitPoUlozeni(_asSelected);
                        })
                }            
                else
                {
                    that.VypravitPoUlozeni(_asSelected);
                }
            } else Wfl.ListAC.WflListBaseAC.ShowInfoNeniVybranZadnyRadek(this);
        }

        VypravitPoUlozeni(_asSelected: Wfl.Interface.GZasilkyVypraveniWorkListDto[])
        {
            const that = this;
            Wfl.ListAC.WflListBaseAC.ClearResultInfo(this);
            that.call("PripravaKVypraveni", { Balickovani: that.VypraveniDto.Balickovani })
                .done(function (data) {
                    switch (that.ZpusobDorProp) {
                        case Wfl.Interface.WflczpdEnum.Posta:
                            that.IfBalickovaniDotaz().done(function (vypravit) { if (vypravit) that.Vypraveni(_asSelected); });
                            break;

                        case Wfl.Interface.WflczpdEnum.EMail:
                            Gin.Globals.ShowWaitInfo(that, "jres:23900079"); //RC 23900079 : Probíhá příprava vypravení
                            that.OdeslatZasilkyFyzicky(_asSelected)
                                .done(function (isOK) {
                                    if (isOK) {
                                        that.Vypraveni(_asSelected);
                                    }
                                })
                                .fail(function (reason) { that.endOperation(); that.dialogs.warning(reason.statusText); });
                            break;

                        case Wfl.Interface.WflczpdEnum.DatovaSchranka:
                            Gin.Globals.ShowWaitInfo(that, "jres:23900079"); //RC 23900079 : Probíhá příprava vypravení
                            that.KontrolaStavuDatovychSchranek(_asSelected).done(function (isOK) {
                                if (isOK) {
                                    Gin.Globals.ShowWaitInfo(that, "jres:23900075"); //RC 23900075 : Probíhá kontrola
                                    that.OvereniDSAdresatu(_asSelected).done(function (isOK) {
                                        if (isOK) {
                                            Gin.Globals.ShowWaitInfo(that, "jres:23900089"); //RC 23900089 : Probíhá odesílání
                                            that.OdeslatZasilkyFyzicky(_asSelected).done(function (isOK) {
                                                if (isOK) {
                                                    that.Vypraveni(_asSelected);
                                                }
                                            })
                                                .fail(function (reason) { Wfl.ListAC.WflListBaseAC.ResolveFaildAkce(that, reason); });
                                        }
                                    }).fail(function (reason) { Wfl.ListAC.WflListBaseAC.ResolveFaildAkce(that, reason); });
                                }
                            }).fail(function (reason) { Wfl.ListAC.WflListBaseAC.ResolveFaildAkce(that, reason); });
                            break;
                        case Wfl.Interface.WflczpdEnum.HybridniPosta:
                            Gin.Globals.ShowWaitInfo(that, "jres:23900079"); //RC 23900079 : Probíhá příprava vypravení
                            that.KontrolaStavuMailboxyHP(_asSelected).done(function (isOK)
                            {
                                that.endOperation();
                                if (isOK)
                                {
                                    that.OdeslatZasilkyFyzicky(_asSelected).done(function (isOK) {
                                        if (isOK) {
                                            that.Vypraveni(_asSelected);
                                        }
                                    })
                                        .fail(function (reason) { Wfl.ListAC.WflListBaseAC.ResolveFaildAkce(that, reason); });
                                }
                            }).fail(function (reason) { Wfl.ListAC.WflListBaseAC.ResolveFaildAkce(that, reason); });
                            break;

                        default:
                            that.Vypraveni(_asSelected)
                            break;
                    }
                });
        }

        CreateActionInfoOZasilkachHP(): GAction
        {
            const that = this;
            var action = new GAction({
                name: Gordic.Wfl.Globals.Enums.ActionsName.InfoOZasilkachHP,
                icon: Gordic.Wfl.Icons.EntitiEnum.informace,
                caption: "jres:23900185", //RC 23900185 : Načíst informace o zásilkách hybridní pošty
                tooltip: "jres:23900185",
                groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite,
                run: function (ev, ctx) {
                    Gordic.Wfl.Dialogs.InfoOZasilkachHPDlg(that, undefined, Gordic.Global.Enums.ModOtevreni.showModalWindow);
                }
            });
            return action;
        }

        CreateActionOveritAdresaty(): GAction {
            const that = this;
            var action = new GAction({
                name: Gordic.Vyp.Globals.Enums.ActionsName.OveritAdresaty,
                icon: Gordic.Gin.Icons.ActionEnum.kontrola,
                caption: "jres:23900073", //RC 23900073 : Ověřit adresáty
                tooltip: "jres:23900073",
                groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite,
                run: function (ev, ctx) {
                    that.resultInfo = [];
                    that.findFields().gfield("model", "collect", that.VypraveniDto);
                    var l_asSelected = that.GetSelectedZasilkyVypraveniListDto();
                    if (l_asSelected.length > 0) {
                        Wfl.ListAC.WflListBaseAC.SetTypProvedenaAkce(that, Wfl.Interface.TypAkce.kontrola);
                        that.KontrolaStavuDatovychSchranek(l_asSelected).done(function (isOK) {
                            if (isOK) {
                                Gin.Globals.ShowWaitInfo(that, "jres:23900075"); //RC 23900075 : Probíhá kontrola
                                that.OvereniDSAdresatu(l_asSelected).done(function (isOK) {
                                    if (isOK) {

                                        Wfl.ListAC.WflListBaseAC.ResolveResultInfo(that, that.resultInfo, Wfl.Interface.TypAkce.kontrola);
                                    }
                                    else {
                                        that.dialogs.warning("jres: 23900074") //RC 23900074 : Akce se nepodařila.
                                    }
                                })
                                .always(function () { that.endOperation(); });
                            }
                        });
                    }
                    else Wfl.ListAC.WflListBaseAC.ShowInfoNeniVybranZadnyRadek(that);
                }
            });
            return action;
        }

        IfBalickovaniDotaz(): JQuery.Promise<boolean> {
            const that = this;
            let promis = $.Deferred<boolean>();

            if (that.VypraveniDto.Balickovani) {
                that.dialogs.confirm("jres:23900014", "jres:23900070").on("close", function (ev, retVal)//RC 23900070 : Chcete ukončit dnešní vypravení zásilek?
                {
                    that.VypraveniDto.UkoncitDnesniVypraveni = retVal && retVal === "yes";
                    promis.resolve(true);
                });
            } else promis.resolve(true);
            return promis.promise();
        }

        Vypraveni(_selected: Wfl.Interface.GZasilkyVypraveniWorkListDto[]): void {
            let that = this;
            Gin.Globals.ShowWaitInfo(that, "jres:23900078"); //RC 23900078 : Probíhá vypravení
            that.call<Gin.Interface.GResultInfo[]>("Vypravit", { Selected: _selected, ResultInfo: that.resultInfo, ModelVypraveni: that.VypraveniDto })
                .done(function (r) {
                    if (r.length > 0)
                    {
                        that.resultInfo = r;
                        //Wfl.ListAC.WflListBaseAC.AddResultInfos(that, r);
                    }

                    that.RefreshData();
                    Wfl.ListAC.WflListBaseAC.SetTypProvedenaAkce(that, Wfl.Interface.TypAkce.vypraveni);

                    //TiskPodArchu pro fyzicke zasilky
                    switch (that.ZpusobDorProp)
                    {
                        case Wfl.Interface.WflczpdEnum.Posta:
                        case Wfl.Interface.WflczpdEnum.DorucovaciSluzba:
                        case Wfl.Interface.WflczpdEnum.Kuryr:

                            if (that.ResultType == Gin.Interface.TypVysledkuOperace.Provedeno)
                            {
                                let tiskPodArch = true;
                                if (that.SessionInfo.Faze == Gin.Interface.FazeGinisuEnum.GWAVYP05)
                                {
                                    tiskPodArch = (that as any).globalSettings.get("Global.Vyp.AppSettings.PrintSettings.TiskPodArch");
                                }
                                if (tiskPodArch === true) that.TiskPodacihoArchuSDialogem();
                            }
                            break;
                    }

                    if (that.paramInfoOStavechHK === 1)
                    {
                        Gordic.Wfl.Dialogs.InfoOZasilkachHPDlg(that, undefined, Gordic.Global.Enums.ModOtevreni.showModalWindow);
                    }
                })
                .always(function () {
                    that.endOperation();                    
                });
        }

        OdeslatZasilkyFyzicky(_selected: Wfl.Interface.GZasilkyVypraveniWorkListDto[]): JQuery.Promise<boolean> {
            let promis = $.Deferred<boolean>();
            const that = this;
            var l_poradi = 1;
            this.PocetCelkem = 0;
            //zjistim pocet k vypraveni
            for (var i = 0; i < _selected.length; i++) {
                if (_selected[i].oznaceni != Gin.Interface.TypOznaceniRadkuSeznamu.Neprovedeno) {
                    _selected[i].poradi = l_poradi;
                    l_poradi += 1;
                    this.PocetCelkem += 1;
                }
            }

            if (this.PocetCelkem > 0) {
                this.Poradi = 0;
                var promises: JQuery.Promise<any>[] = [];
                for (var i = 0; i < _selected.length; i++) {
                    if ((_selected as Gordic.Wfl.Interface.GZasilkyWorkListDto).oznaceni != Gin.Interface.TypOznaceniRadkuSeznamu.Neprovedeno) {
                        switch (that.ZpusobDorProp) {
                            case Wfl.Interface.WflczpdEnum.EMail:
                                promises.push(that.SendSignedMessage(_selected[i]));
                                break;
                            case Wfl.Interface.WflczpdEnum.DatovaSchranka:
                                promises.push(that.SendMessage(_selected[i]));
                                break;
                            case Wfl.Interface.WflczpdEnum.HybridniPosta:
                                promises.push(that.SendMessage(_selected[i]));
                                break;
                            default: that.dialogs.warning("ERROR 23920045");
                                break
                        }
                    }
                }

                $.when.apply(null, promises).done(
                    function () {
                        var l_ok = Gordic.Wfl.Common.GetPocetProvedenych(that.resultInfo) > 0;
                        if (that.VypraveniDto.VratitNevypravene)
                        {
                            switch (that.ZpusobDorProp) {
                                case Wfl.Interface.WflczpdEnum.DatovaSchranka:
                                case Wfl.Interface.WflczpdEnum.HybridniPosta:
                                    l_ok = true;
                                    break;
                            }
                        }

                        l_ok = true;
                        Wfl.ListAC.WflListBaseAC.ResolveResultInfo(that, that.resultInfo, Wfl.Interface.TypAkce.vypraveni, true);
                        promis.resolve(l_ok);
                    });
            }
            else {
                promis.resolve(false);
            }
            return promis.promise();
        }

        // odeslani jednouho radku
        SendMessage(item: Wfl.Interface.GZasilkyVypraveniWorkListDto, sign?: Gordic.Wfl.WebClient.GSignatureResultDtoWithGuids): JQuery.Promise<boolean> {
            let promis = $.Deferred<boolean>();
            var that = this;
            Wfl.ListAC.WflListBaseAC.ShowWaitInfoProgress(this, "jres:23900081", true);

            that.call<Gin.Interface.GResultInfo>("OdeslatZasilku", { Sxs: item.sxs, Sign: sign })
                .done(function (r) {
                    if (r) {
                        Wfl.ListAC.WflListBaseAC.AddResultInfo(that, r);
                        item.oznaceni = Gordic.Gin.Globals.GetTypOznaceniRadkuSeznamu(r.Vysledek!);
                        item.err_status = r.Info;
                        that.endOperation();
                        promis.resolve(true);
                    }
                    else {
                        item.oznaceni = Gordic.Gin.Interface.TypOznaceniRadkuSeznamu.Neprovedeno;
                        item.info = "ERROR 23920077";
                        that.endOperation();
                        promis.resolve(false);
                    }
                })
                .fail(function (retVal) {
                    Wfl.ListAC.WflListBaseAC.ResolveFaildRadku(that, item.sxs!, retVal.statusText);
                    item.oznaceni = Gordic.Gin.Interface.TypOznaceniRadkuSeznamu.Neprovedeno;
                    promis.resolve(false);
                })
            return promis.promise();
        }

        // odeslani jednouho radku mailu
        SendSignedMessage(item: Wfl.Interface.GZasilkyVypraveniWorkListDto): JQuery.Promise<boolean> {
            let promis = $.Deferred<boolean>();
            const that = this;
            if (item.s_sign && item.s_sign > 0) // podepisovat
            {
                Wfl.ListAC.WflListBaseAC.ShowWaitInfoProgress(this, "jres:23900088");
                that.call<Gin.Interface.GResultInfo>("CreateMail", { Sxs: item.sxs })
                    .done(function (r) {
                        if (r) {
                            item.oznaceni = Gordic.Gin.Globals.GetTypOznaceniRadkuSeznamu(r.Vysledek!);
                            switch (r.Vysledek) {
                                case Gordic.Gin.Interface.TypVysledkuOperace.Provedeno:
                                    that.CreateSign(item.sxs!, r.Info!)
                                        .done(function (sign)
                                        {
                                            that.endOperation();
                                            if (sign) {
                                                that.SendMessage(item, sign).done(function (r) {
                                                    if (r) promis.resolve(r);
                                                    else promis.resolve(false);
                                                })
                                            }
                                            else { promis.resolve(false); }
                                            }
                                        )
                                        .fail(function (reason) { that.endOperation(); that.dialogs.warning(reason.statusText); })
                                    break;
                                default:
                                    that.resultInfo.push(r)
                                    promis.resolve(false);
                                    break;
                            }
                        }
                        else {
                            item.oznaceni = Gordic.Gin.Interface.TypOznaceniRadkuSeznamu.Neprovedeno;
                            promis.resolve(false);
                        }
                    })
                    .fail(function (reason) {
                        that.endOperation();
                        item.oznaceni = Gordic.Gin.Interface.TypOznaceniRadkuSeznamu.Neprovedeno;
                        Wfl.ListAC.WflListBaseAC.ResolveFaildRadku(that, item.sxs!, reason.statusText);
                        promis.resolve(false);
                    })
            }
            else // je nutno vytvorit mail a podepsat
            {
                that.SendMessage(item).done(function (r) {
                    if (r) promis.resolve(r);
                    else promis.resolve(false);
                }).fail(function (reason) {
                    Wfl.ListAC.WflListBaseAC.ResolveFaildRadku(that, item.sxs!, "ERROR 23920050")
                });
            }
            return promis.promise();
        }

        CreateSign(_sxs: string, guid: string): JQuery.Promise<Gordic.Wfl.WebClient.GSignatureResultDtoWithGuids|null> {
            let promis = $.Deferred<Gordic.Wfl.WebClient.GSignatureResultDtoWithGuids | null>();
            const that = this;
            //var fileName = "Mail{0}.eml".format(Date().format("YYYYMMDDhhmmss"));
            var fileName = "MailKVypraveni_" + _sxs + ".eml";

            Gordic.Wfl.Utils.SignObj.PodepisovaniApp.sign
                ({
                    file: guid,
                    fileName: fileName,
                    signTime: new Date(),
                    idSigningReason: this.IxsDpo
                })
                .then((signedConfig: Gordic.Wfl.WebClient.GSignatureResultDtoWithGuids) => {
                    promis.resolve(signedConfig);
                }, (reason) => { //fail
                        that.endOperation(); 
                        Gordic.Gui.WebApp.Utils.showReasonFlash(that, reason);
                        if (!reason.handled) { that.dialogs.warning(reason.reason); }         
                        promis.resolve(null);
                    })
            return promis.promise();
        }

        TiskPodacihoArchuSDialogem(): void
        {
            const that = this;

            that.dialogs.messageBox("jres:23900014", "jres:23900065", [{ id: "ano", text: "jres:23900066" }, { id: "dopor", text: "jres:23900067" }, { id: "ne", text: "jres:23900068" },]) //RC 23900067 : Ano - dopor.
                .on("close", function (ev, ctx) {
                    var l_typ: Gordic.Vyp.Globals.Enums.TypTiskuPodacihoArchu = Gordic.Vyp.Globals.Enums.TypTiskuPodacihoArchu.netisknou;

                    switch (ctx) {
                        case "ano":
                            l_typ = Gordic.Vyp.Globals.Enums.TypTiskuPodacihoArchu.tisknout;
                            break;
                        case "dopor":
                            l_typ = Gordic.Vyp.Globals.Enums.TypTiskuPodacihoArchu.tisknoutDoporucene;
                            break;
                    }
                    if (l_typ != Gordic.Vyp.Globals.Enums.TypTiskuPodacihoArchu.netisknou) VypListBasePage.TiskPodacihoArchuPriprava(that, l_typ)
                });
           
        }

        KontrolaStavuDatovychSchranek(_selected: Wfl.Interface.GZasilkyVypraveniWorkListDto[]): JQuery.Promise<boolean> {
            let promis = $.Deferred<boolean>();
            const that = this;
            var selected = that.mainGrid.ggrid<Wfl.Interface.GSeznamZasilekDto>("getSelection").map((o) => { return { Id: o.id_ds_odes }; }) as Wfl.Interface.GSeznamId[];
            Gin.Globals.ShowWaitInfo(that, "jres:23900075"); //RC 23900075 : Probíhá kontrola
            this.call<Gordic.Wfl.Interface.GSeznamId[]>("GetZamceneMailboxy", { DsOdes: selected })
                .done(function (zamceneMailboxy) {   
                    if (zamceneMailboxy.length > 0) {
                        that.dialogs.confirm("jres:23900014", "jres:23900029").on("close", function (ev, retVal)//RC 23900029 : Odemknout zamčené schránky?
                        {
                            if (retVal && retVal === "yes") {
                                that.OdemknoutZamceneMailboxy(zamceneMailboxy);
                            } else promis.resolve(false);
                        });
                    }
                    else {
                        promis.resolve(true);
                    }
                })
                .fail(function (reason) { that.endOperation(); that.dialogs.warning(reason.statusText); });
            return promis.promise();
        }

        KontrolaStavuMailboxyHP(_selected: Wfl.Interface.GZasilkyVypraveniWorkListDto[]): JQuery.Promise<boolean> {
            let promis = $.Deferred<boolean>();
            const that = this;
            Gin.Globals.ShowWaitInfo(that, "jres:23900075"); //RC 23900075 : Probíhá kontrola
            this.call<Gin.Interface.GResultInfo>("KontrolaZamkuOdeslani")
                .done(function (res) {
                    if (res.Vysledek == Gordic.Gin.Interface.TypVysledkuOperace.Neprovedeno)
                    {
                        that.endOperation();
                        that.dialogs.confirm("jres:23900014", res.Info!).on("close", function (ev, retVal)
                        {
                            if (retVal && retVal === "yes")
                            {
                                that.OdemknoutZamekOdeslani().done(function (isOK)
                                {
                                    promis.resolve(isOK);
                                });
                            } else promis.resolve(false);
                        });
                    }
                    else {
                        that.endOperation();
                        promis.resolve(true);
                    }
                })
                .fail(function (reason) { that.endOperation(); that.dialogs.warning(reason.statusText); });
            return promis.promise();
        }

        IfOverovatDSAdresatu(): JQuery.Promise<boolean> {
            let promis = $.Deferred<boolean>();
            switch (this.VypraveniDto.OverovatDSAdresatu) {
                case 2:
                    promis.resolve(true);
                    break;
                case 1:
                    this.dialogs.confirm("jres:23900014", "jres:23900069").on("close", function (ev, retVal) { //RC 23900014 : Dotaz
                        if (retVal === "yes") {
                            promis.resolve(true);
                        } else {
                            promis.resolve(false);
                        }
                    });
                    break;
                default:
                    promis.resolve(false);
                    break;
            }
            return promis.promise();
        }

        // kontrola jednouho radku
        KontrolaDSAdresatu(item: Wfl.Interface.GZasilkyVypraveniWorkListDto): JQuery.Promise<any> {
            let promis = $.Deferred<any>();
            var IsGex = this.ZpusobDorProp == Wfl.Interface.WflczpdEnum.GEX;
            const that = this;
            if (item.oznaceni != Gordic.Gin.Interface.TypOznaceniRadkuSeznamu.Neprovedeno) {
                var l_res: Gin.Interface.GResultInfo = {};
                l_res.Ixs = item.sxs;
                Wfl.ListAC.WflListBaseAC.ShowWaitInfoProgress(this, "jres:23900080");
    
                Gordic.Esu.Utils.OverISDSzWFL({
                    flagGex: IsGex ? "1" : "0",
                    content: this,
                    //Ucel: false,
                    PrevzitVOkne: true,
                    IxsEsu: item.ixs_esu as string,
                    overovatJenExistenciSchranky: this.SessionInfo.IsVyvoj ? "1" : "0" // "1;" = jenom existenci
                })
                    .done(function (retVal) {
                        //that.endOperation();
                        if (retVal && retVal.stav && typeof retVal.stav === "string") {
                            switch (retVal.stav) {
                                case "nalezeno":
                                    l_res.ErrorText = "";
                                    l_res.Vysledek = Gordic.Gin.Interface.TypVysledkuOperace.Provedeno;
                                    break;

                                case "prevzato":
                                    l_res.ErrorText = "jres:23900077"; //RC 23900077 : Data adresáta byla převzata z ISDS
                                    l_res.Vysledek = Gordic.Gin.Interface.TypVysledkuOperace.Provedeno;
                                    break;

                                case "neprevzato":
                                    l_res.ErrorText = "Data adresáta nebyla převzata z ISDS";
                                    l_res.Vysledek = Gordic.Gin.Interface.TypVysledkuOperace.ProvedenoSUpozornenim;
                                    break;

                                case "nenalezeno":
                                    if (IsGex) {
                                        //zacniOvereni(TypSchranky.Ds);
                                    }
                                    else {
                                        l_res.ErrorText = "Datová schránka adresáta nebyla nalezena";
                                        l_res.Vysledek = Gordic.Gin.Interface.TypVysledkuOperace.Neprovedeno;
                                        item.oznaceni = Gordic.Gin.Interface.TypOznaceniRadkuSeznamu.Neprovedeno;
                                        item.info = l_res.ErrorText;
                                    }
                                    break;

                                default:
                                    l_res.Vysledek = Gordic.Gin.Interface.TypVysledkuOperace.Neprovedeno;
                                    l_res.ErrorText = retVal.stav;
                                    break;
                            }
                            that.resultInfo.push(l_res);
                        }
                        else {
                            l_res.ErrorText = "CHYBA 23920036";
                            l_res.Vysledek = Gordic.Gin.Interface.TypVysledkuOperace.Neprovedeno;
                            item.oznaceni = Gordic.Gin.Interface.TypOznaceniRadkuSeznamu.Neprovedeno;
                            item.info = l_res.ErrorText;
                            that.resultInfo.push(l_res);
                            //vyhodnotOvereni({ stav: "fail" }, overGex);
                        }
                        promis.resolve(true);
                    })
                    .fail(function (retVal)
                    {
                        that.endOperation();
                        l_res.ErrorText = "CHYBA 23920037 " + retVal as string;
                        l_res.Vysledek = Gordic.Gin.Interface.TypVysledkuOperace.Neprovedeno;
                        l_res.Vysledek = Gordic.Gin.Interface.TypVysledkuOperace.Neprovedeno;
                        that.resultInfo.push(l_res);
                        promis.resolve(false);
                        //vyhodnotOvereni({ stav: "fail" }, overGex);
                    })
                    ;
            }
            return promis.promise();
        }

        OvereniDSAdresatu(_selected: Wfl.Interface.GZasilkyVypraveniWorkListDto[]): JQuery.Promise<boolean> {
            let promis = $.Deferred<boolean>();
            const that = this;

            for (var i = 0; i < _selected.length; i++)
            {
                _selected[i].poradi = i;
                if (!_selected[i].ixs_esu) {
                    _selected[i].oznaceni = Gordic.Gin.Interface.TypOznaceniRadkuSeznamu.Neprovedeno;
                    _selected[i].info = "jres:23900072"
                }
            }
            that.PocetCelkem = _selected.length;
            this.Poradi = 0;
            this.IfOverovatDSAdresatu().done(function (overit) {
                if (overit) {

                    var promises: JQuery.Promise<any>[] = [];
                    for (var i = 0; i < _selected.length; i++) {
                        promises.push(that.KontrolaDSAdresatu(_selected[i]));
                    }

                    $.when.apply(null, promises).done(
                        function () {
                            promis.resolve(true);
                        });

                } else promis.resolve(true);
            })
            return promis.promise();
        }

        OdemknoutZamceneMailboxy(lockedMaibox: Gordic.Wfl.Interface.GSeznamId[]): JQuery.Promise<boolean> {
            let promis = $.Deferred<boolean>();
            const that = this;
            Gin.Globals.ShowWaitInfo(this, "jres:23900076"); //RC 23900076 : Odemykám zamčené schránky
            this.call<Gordic.Gin.Interface.GResultInfo>("OdemknoutZamceneMaiboxy", { LockedMaibox: lockedMaibox })
                .done(function (r) {
                    promis.resolve(r && r.Vysledek == Gordic.Gin.Interface.TypVysledkuOperace.Provedeno);
                })
                .always(function () {
                    that.endOperation();
                });
            return promis.promise();
        }

        OdemknoutZamekOdeslani(): JQuery.Promise<boolean> {
            let promis = $.Deferred<boolean>();
            const that = this;
            Gin.Globals.ShowWaitInfo(this, "jres:23900076"); //RC 23900076 : Odemykám zamčené schránky
            this.call<Gordic.Gin.Interface.GResultInfo>("OdemkniZamekOdeslani")
                .done(function (r) {
                    promis.resolve(true);
                })
                .always(function () {
                    that.endOperation();
                });
            return promis.promise();
        }

        GetSelectedZasilkyVypraveniListDto(): Wfl.Interface.GZasilkyVypraveniWorkListDto[] {
            return this.mainGrid.ggrid<Wfl.Interface.GSeznamZasilekDto>("getSelection").map((o) => { return { sxs: o.sxs, ixs_esu: o.ixs_esu, akt_ixs_su: o.akt_ixs_su, start_ixs_su: o.start_ixs_su, start_ixs_fun: o.start_ixs_fun, s_sign: o.s_sign }; }) as Wfl.Interface.GSeznamZasilekDto[];
        }
    }
}

